import { render, staticRenderFns } from "./search-filters-skeleton.vue?vue&type=template&id=2fe37aaa"
import script from "./search-filters-skeleton.vue?vue&type=script&lang=js"
export * from "./search-filters-skeleton.vue?vue&type=script&lang=js"
import style0 from "./search-filters-skeleton.vue?vue&type=style&index=0&id=2fe37aaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports